if (signed_in) {
    if (!localStorage.getItem('signed_in')) {
        window.dataLayer.push({
            event: 'user_login_success'
        });
        localStorage.setItem('signed_in', true);
    }
} else {
    if (localStorage.getItem('signed_in')) {
        localStorage.removeItem('signed_in');
    }
}